import React, { useMemo, useState } from "react";
import {
	MaterialReactTable,
	useMaterialReactTable,
} from "material-react-table";

import "./Corrections.scss";

import { Button, COLORS, Icon, Modal } from "abs-ui-components";

import CorrectionRequestForm from "./CorrectionRequestForm";
import AbsModal from "../../../common/absModal/AbsModal";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";
import { convertLocaltoUTCFormat } from "../../../services/DateFormatUtility";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CorrectionsChildTable = ({
	parentCorrectionData,
	reportDetails,
	fetchData,
}) => {
	const [correctionMsgConfirmDelete, setCorrectionMsgConfirmDelete] =
		useState(false);
	const [rowSelection, setRowSelection] = useState({});
	const [selectAll, setSelectAll] = useState(false);

	const correctionListSubColumns = useMemo(
		() => [
			{
				accessorKey: "message",
				header: "Messages",
			},
			{
				accessorKey: "createdBy",
				header: "Created By",
			},
			{
				accessorKey: "createdDate",
				header: "Created",
				accessorFn: (row) => {
					if (row.createdDate) {
						return convertLocaltoUTCFormat(row.createdDate);
					}
				},
			},
		],
		[]
	);

	const [isCorrectionMsgModalOpen, setIsCorrectionMsgModalOpen] =
		useState(false);

	const toggleCorrectionMessage = () => {
		setIsCorrectionMsgModalOpen(!isCorrectionMsgModalOpen);
	};

	// (delete method)
	const handleDeletingcorrectionMessages = (
		selectedDeletCorrectionMessagesRows
	) => {
		axiosHttp({
			url: `${BASE_URL}api/Corrections/DeleteCorrectionMessages`,
			method: "DELETE",
			data: {
				reportCorrectionsMsgsIds: selectedDeletCorrectionMessagesRows,
			},
		})
			.then((res) => {
				if (res) {
					emitToasterMsg(
						"success",
						"Correction Message",
						"Deleted Successfully"
					);
					setCorrectionMsgConfirmDelete(false);
					setRowSelection({});
					fetchData();
				}
			})
			.catch((err) => {
				setCorrectionMsgConfirmDelete(false);
				emitToasterMsg("error", "Correction Message", err.message);
			});
	};

	const handleSelectAll = (event) => {
		setSelectAll(event.target.checked);
	};

	const childTable = useMaterialReactTable({
		columns: correctionListSubColumns,
		data: parentCorrectionData?.reportCorrectionsMsgs || [],
		enableRowSelection: true,
		enableStickyHeader: true,
		enableBottomToolbar: false,
		enableTopToolbar: reportDetails?.IsParentReport ? true : false,
		enablePagination: false,
		manualFiltering: true,
		manualSorting: true,
		filterFromLeafRows: true,
		onRowSelectionChange: setRowSelection,
		getRowId: (row) => row.reportCorrectionsMsgsId,
		state: { rowSelection },
		initialState: {
			density: "compact",
			columnOrder: ["Message", "CreatedBy", "Created"],
		},

		muiTableBodyRowProps: () => ({
			sx: {
				cursor: "pointer",
			},
		}),

		muiTableContainerProps: {
			sx: {
				maxHeight: "calc(100vh - 379px)",
				padding: 0,
				margin: 0,
			},
		},
		muiTableBodyCellProps: {
			sx: {
				paddingTop: 0,
				marginTop: 0,
				marginBottom: 0,
				paddingBottom: 0,
			},
		},
		renderToolbarInternalActions: ({ table }) => <></>,
		muiTableHeadCellProps: ({ column }) => ({
			id: `${column.columnDef.accessorKey}`,
			sx: {
				color: "rgb(255 255 255)",
				"& .MuiButtonBase-root": {
					color: "white !important",
					"& .MuiTableSortLabel-icon": {
						color: "white !important",
					},
				},
			},
		}),
		muiFilterTextFieldProps: {
			sx: {
				"& .MuiInput-root": {
					color: "white !important",
				},
				"& .MuiButtonBase-root": {
					color: "white !important",
				},
				"& .MuiInputBase-root::after": {
					transform: "none",
					borderBottom: "2px solid white",
				},
			},
		},
		muiColumnActionsButtonProps: {
			sx: {
				color: "white",
			},
		},
		muiSelectAllCheckboxProps: {
			title: selectAll ? "Toggle deselect all" : "Toggle select all",
			onClick: (e) => handleSelectAll(e),
			disabled: parentCorrectionData?.reportCorrectionsMsgs?.length === 0,
			sx: {
				color: "white",
			},
		},
		muiTableHeadRowProps: {
			sx: {
				backgroundColor: "#042a4c !important",

				"& .MuiTableCell-head::before": {
					backgroundColor: "#042a4c !important",
				},
			},
		},
		muiTablePaperProps: {
			sx: {
				boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
			},
		},
		renderTopToolbarCustomActions: ({ table }) => (
			<>
				<div className="container-fluid">
					<div className="row p-0 m-0 d-flex align-items-center mt-2">
						<Button
							startIcon={<Icon icon="add" />}
							variant="secondary"
							className="ml-2"
							onClick={toggleCorrectionMessage}
						>
							REPLY
						</Button>
						<Button
							onClick={() => setCorrectionMsgConfirmDelete(true)}
							primaryBackgroundColor={COLORS.RED.DARK}
							primaryColor={COLORS.RED.DARK}
							disabled={
								Object.keys(rowSelection).length === 0
									? true
									: false
							}
							startIcon={<Icon icon="delete" />}
							className="ml-2 delete-btn"
						>
							DELETE
						</Button>
					</div>
				</div>
			</>
		),
	});

	return (
		<>
			&nbsp;
			<MaterialReactTable table={childTable} />
			&nbsp;
			<div className="corrections-request-form-child">
				{isCorrectionMsgModalOpen && (
					<AbsModal
						isOpen={isCorrectionMsgModalOpen}
						title="Correction Request"
						onClose={setIsCorrectionMsgModalOpen}
						close={toggleCorrectionMessage}
					>
						<CorrectionRequestForm
							toggleCorrection={toggleCorrectionMessage}
							reportDetails={reportDetails}
							isRepliedCorrection={true}
							parentCorrectionData={parentCorrectionData}
							fetchData={fetchData}
						/>
					</AbsModal>
				)}
			</div>
			<div className="confirmation-modal-container">
				<Modal
					isOpen={correctionMsgConfirmDelete}
					modalHeader
					padding={"70px"}
					headerHeight={"50px"}
					showFooter
					onCloseClickListener={() => {
						setCorrectionMsgConfirmDelete(false);
					}}
					footer={
						<div className="d-flex justify-content-end fixed-action-btns p-4 footer">
							<Button
								className="delete-btn"
								onClick={() =>
									handleDeletingcorrectionMessages(
										Object.keys(rowSelection).map(Number)
									)
								}
								primaryColor={COLORS.RED.DARK}
								primaryBackgroundColor={COLORS.RED.LIGHT}
							>
								Delete
							</Button>
							<Button
								className="modal-cancel-btn"
								onClick={() => {
									setCorrectionMsgConfirmDelete(false);
								}}
							>
								Cancel
							</Button>
						</div>
					}
				>
					<div>Are you sure you want to delete the message(s)?</div>
				</Modal>
			</div>
		</>
	);
};

export default CorrectionsChildTable;
